import type { SVGProps } from 'react';

const SvgMaleBd = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M12 10.5C9.23858 10.5 7 12.7386 7 15.5C7 18.2614 9.23858 20.5 12 20.5C14.7614 20.5 17 18.2614 17 15.5C17 12.7386 14.7614 10.5 12 10.5ZM12 10.5L12 3.5M7 7.5L12 3.5M12 3.5L17 7.59091'
      stroke='currentColor'
      strokeWidth={2}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
export default SvgMaleBd;
